import { ISectionModel } from '@src/slide/domain/ui-model/element-modeles/Interface/section-model.interface';

/**
 * slide 列表间隙相关换算方法
 */
export default class ClearanceUtils {
    public static calcClearanceIndexFromSlideIndex(slideIndex: number, sectionList: ISectionModel[]): number {
        if (!sectionList || sectionList.length === 0) {
            return -1;
        }
        let numSectionsBeforeCell = 0;
        let numCells = 0;
        for (; numSectionsBeforeCell < sectionList.length; numSectionsBeforeCell += 1) {
            if (slideIndex < numCells + sectionList[numSectionsBeforeCell].numSlides) {
                break;
            }
            numCells += sectionList[numSectionsBeforeCell].numSlides;
        }
        return slideIndex + numSectionsBeforeCell + 1;
    }

    public static calcSectionIndexFromClearanceIndex(clearanceIndex: number, sectionList: ISectionModel[]): number {
        if (!sectionList || sectionList.length === 0) {
            return -1;
        }
        let prevSectionCount = 0;
        let index = 0;
        while (
            prevSectionCount < sectionList.length
            && clearanceIndex > sectionList[prevSectionCount].numSlides + index
        ) {
            index += sectionList[prevSectionCount].numSlides + 1;
            prevSectionCount += 1;
        }
        return Math.min(prevSectionCount, sectionList.length - 1);
    }

    public static calcSectionIndexFromSlideIndex(slideIndex: number, sectionList: ISectionModel[]): number {
        if (!sectionList || sectionList.length === 0) {
            return -1;
        }
        let curIndex = 0;
        let sectionIndex = 0;
        while (sectionIndex < sectionList.length && slideIndex >= curIndex + sectionList[sectionIndex].numSlides) {
            curIndex += sectionList[sectionIndex].numSlides;
            sectionIndex += 1;
        }
        return sectionIndex;
    }

    public static calcSlideIndexFromClearanceIndex(clearanceIndex: number, sectionList: ISectionModel[]): number {
        if (!sectionList || sectionList.length === 0) {
            return clearanceIndex;
        }
        return clearanceIndex - this.calcSectionIndexFromClearanceIndex(clearanceIndex, sectionList);
    }

    public static calcFirstSlideIndexFromSectionIndex(sectionIndex: number, sectionList: ISectionModel[]): number {
        if (!sectionList || sectionList.length === 0) {
            return -1;
        }
        return sectionList.slice(0, sectionIndex).reduce((acc, cur) => acc + cur.numSlides, 0);
    }

    public static calcClearanceIndexFromSectionIndex(sectionIndex: number, sectionList: ISectionModel[]): number {
        if (!sectionList || sectionList.length === 0) {
            return -1;
        }
        let res = 0;
        for (let i = 0; i < sectionIndex; i += 1) {
            res = res + 1 + sectionList[i].numSlides;
        }
        return res;
    }
}
